module.exports = __webpack_public_path__ + "static/about_1-51a55453c2fd28819c007cd319182ac3.png";